<template>
  <div class="column">
    <div class="mrs mbm flex-container">
      <span class="text-left medium-3 small-12">
        <h6>Auszahlungsprotokoll</h6>
        Verdient: {{ earnings }}
      </span>
      <div class="text-right medium-9 small-12">
        <div class="row">
          <div class="small-12 medium-6 flex-container align-middle">
            <label for="status">Stand:</label>
            <select v-model="status" :disabled="!enabled" class="mbn mls mrs">
              <option
                v-for="(option, index) in statusOptions"
                :key="index"
                :value="option.value"
                :disabled="!enabled"
                class="mls mr"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div class="small-12 medium-6 flex-container align-middle">
            <label for="sortBy" style="white-space: nowrap"
              >Nach %0 sortieren:</label
            >
            <select v-model="sortBy" :disabled="!enabled" class="mbn mls">
              <option
                v-for="(option, index) in sortOptions"
                :key="index"
                :value="option.value"
                :disabled="!enabled"
                class="mls mrs"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      required: true,
    },
    earnings: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      status: null,
      sortBy: null,
      statusOptions: [
        {
          label: 'Alle',
          value: null,
        },
        {
          label: 'Interim',
          value: 'Interim',
        },
        {
          label: 'Ausstehend',
          value: 'Pending',
        },
        {
          label: 'Genehmigt',
          value: 'Approved',
        },
        {
          label: 'Fertig',
          value: 'Completed',
        },
        {
          label: 'gehalten',
          value: 'Held',
        },
        {
          label: 'Fehlgeschlagen',
          value: 'Failed',
        },
      ],
      sortOptions: [
        {
          label: 'Ausgewähltes Datum',
          value: null,
        },
        {
          label: 'Zahlungstermin',
          value: 'Payment Date',
        },
        {
          label: 'Stand',
          value: 'Status',
        },
      ],
    };
  },
  watch: {
    async status(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.update();
      }
    },
    async sortBy(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.update();
      }
    },
  },
  methods: {
    async update() {
      if (!this.enabled) {
        return;
      }
      this.$emit('filter-update', {
        status: this.status,
        sortBy: this.sortBy,
      });
    },
  },
};
</script>
